import excelente1 from "../assets/bg/excelente-avatar-1.png";
import excelente2 from "../assets/bg/excelente-avatar-2.png";
import excelente3 from "../assets/bg/excelente-avatar-3.png";
import excelente4 from "../assets/bg/excelente-avatar-4.png";

const EXCELENTE_AVATARS = [excelente1, excelente2, excelente3, excelente4];

/**
 * URL (bundler) de un avatar «Excelente» al azar.
 * En componentes React, suele usarse dentro de useMemo([], []) para fijar uno por visita.
 */
export function getRandomExcelenteAvatar() {
	return EXCELENTE_AVATARS[Math.floor(Math.random() * EXCELENTE_AVATARS.length)];
}
